// export default function compileErrors(err){
    
//     var commonErrMsg = "Something went wrong!!! Please try again in sometime";
//     var msg = "";
//     if("exceptionMessage" in err){
//         var exp = err.exceptionMessage;
//         if(typeof exp=="object"){        
//             if("errors" in exp){
//                 var expErr = exp.errors;
//                 if(typeof expErr=="object"){
//                     for (var key in expErr) {
//                         if (expErr.hasOwnProperty(key)) {
//                             var val = expErr[key];
//                             if(typeof val=="object" || typeof val=="array"){
//                                 for (var key1 in val) {
//                                        if (val.hasOwnProperty(key1)) { 
//                                         var val1 = val[key1];
//                                         msg += (val1!=null && typeof val1=="string")?(val1+", ") :"";
//                                        }
//                                 }
//                             }else{
//                                 msg += (val!=null && typeof val=="string")?(val+", ") :"";
//                             }
//                         }
//                     }
//                 }
//                 else{
//                     msg += (expErr!=null && typeof expErr=="string")?(expErr+", ") : "";
//                 }
//             }
//         }else{
//             msg += (exp!=null && typeof exp=="string")?(exp+", ") : "";
//         }
//     }
//     msg = msg.trim(); 
//     msg = msg.replace(/,(?=\s*$)/, '')
//     return msg==""?commonErrMsg:msg;
// }


export default function compileErrors(err) {
    var commonErrMsg = "Something went wrong!!! Please try again in sometime";
    var msg = "";

    // Check if "exceptionMessage" exists in the error
    if ("exceptionMessage" in err) {
        var exp = err.exceptionMessage;

        // Check if "ResponseMessage" exists in "exceptionMessage"
        if (exp.ResponseMessage) {
            return exp.ResponseMessage;
        }

        // If "exceptionMessage" is an object
        if (typeof exp == "object") {
            if ("errors" in exp) {
                var expErr = exp.errors;
                if (typeof expErr == "object") {
                    for (var key in expErr) {
                        if (expErr.hasOwnProperty(key)) {
                            var val = expErr[key];
                            if (typeof val == "object" || Array.isArray(val)) {
                                for (var key1 in val) {
                                    if (val.hasOwnProperty(key1)) {
                                        var val1 = val[key1];
                                        msg += (val1 != null && typeof val1 == "string") ? (val1 + ", ") : "";
                                    }
                                }
                            } else {
                                msg += (val != null && typeof val == "string") ? (val + ", ") : "";
                            }
                        }
                    }
                } else {
                    msg += (expErr != null && typeof expErr == "string") ? (expErr + ", ") : "";
                }
            }
        } else {
            msg += (exp != null && typeof exp == "string") ? (exp + ", ") : "";
        }
    }

    // Trim and clean up the message
    msg = msg.trim();
    msg = msg.replace(/,(?=\s*$)/, '');
    return msg == "" ? commonErrMsg : msg;
}
